import type { NavigateOptions } from "@tanstack/react-router";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

const useBackEscape = ({ to, params }: NavigateOptions): void => {
	const navigate = useNavigate();

	useEffect(() => {
		const handleBackEscape = (event: KeyboardEvent): void => {
			if (event.key !== "Escape") {
				return;
			}

			navigate({ to, params }).catch(console.error);
		};

		globalThis.addEventListener("keydown", handleBackEscape);

		return (): void => {
			globalThis.removeEventListener("keydown", handleBackEscape);
		};
	}, [navigate, to, params]);
};

export { useBackEscape };
